module.exports = __webpack_public_path__ + "static/media/bi03en.7216f28a.png";